import type { HTMLAttributes, LabelHTMLAttributes, ReactNode } from 'react'
import { cn } from '#lib/utils'

export function Field({ className, ...props }: HTMLAttributes<HTMLDivElement>): ReactNode {
  return <div className={cn('space-y-1.5', className)} {...props} />
}

export function FieldLabel({
  className,
  ...props
}: LabelHTMLAttributes<HTMLLabelElement>): ReactNode {
  return (
    <label
      className={cn('block text-[11px] font-medium text-muted-foreground', className)}
      {...props}
    />
  )
}

export function FieldHint({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>): ReactNode {
  return <p className={cn('text-[11px] leading-4 text-muted-foreground', className)} {...props} />
}

export function FieldError({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>): ReactNode {
  return <p className={cn('text-[11px] leading-4 text-destructive', className)} {...props} />
}
